import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ContentTextComponent extends Vue {
    @Prop()
    contentId: string;

    contentBody: string;

    state: string = 'loading';

    mounted() {
        this.loadModel();
    }

    loadModel() {
        new api.ContentService().getText(this.contentId).then(
            (result: api.ContentText) => {
                this.contentBody = result.body;
                this.state = 'success';
            },
            (error) => {
                this.state = 'failed';

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }
}
